<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBVatRateForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBVatRateList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBVatRateForm from './Form.vue'

export default {
  components: {
    EXSBVatRateForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbvatrate/update/isLoading',
      error: 'exsbvatrate/update/error',
      deleteError: 'exsbvatrate/del/error',
      deleteLoading: 'exsbvatrate/del/isLoading',
      created: 'exsbvatrate/create/created',
      deleted: 'exsbvatrate/del/deleted',
      retrieved: 'exsbvatrate/update/retrieved',
      updated: 'exsbvatrate/update/updated',
      violations: 'exsbvatrate/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBVatRateList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbvatrate/create/reset',
      deleteItem: 'exsbvatrate/del/del',
      delReset: 'exsbvatrate/del/reset',
      retrieve: 'exsbvatrate/update/retrieve',
      updateReset: 'exsbvatrate/update/reset',
      update: 'exsbvatrate/update/update',
      updateRetrieved: 'exsbvatrate/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbvatrate ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
